import './style/bolmateImageFallback.scss';

import {Icon} from '@iconify/react';

import classNames from 'classnames';

import React, {useState} from 'react';

interface Props {
    src: string | null | undefined;
    alt?: string;
    fallbackIcon?: string;
    className?: string;
    imageClassName?: string;
}

export default function BolmateImageFallback(props: Props) {
    const {src, alt = '', fallbackIcon = 'mdi:package-variant-closed', className, imageClassName} = props;
    const [error, setError] = useState(false);

    function onError() {
        setError(true);
    }

    if (src && !error) {
        return <img src={src} alt={alt} className={classNames('bolmate-image', imageClassName)} onError={onError} />;
    }

    return (
        <div className={classNames('bolmate-image-fallback', className)}>
            <Icon icon={fallbackIcon} className='bolmate-image-fallback-icon' />
        </div>
    );
}
